import { getActivatedVideoElementIfAvailable } from '@core/video/videoElementWrapper/cache';
import { resolveWrapperClass } from './resolveWrapperClass';
export const previousWrapper = {};
/**
 *
 */
export const discardWrapper = (key) => {
    previousWrapper[key]?.reset(key);
    delete previousWrapper[key];
};
/**
 *
 */
export async function videoWrapperFactory(video, options) {
    const { key, preferredCDNs } = options;
    const WrapperClass = await resolveWrapperClass(video);
    if (previousWrapper[key] instanceof WrapperClass &&
        previousWrapper[key]?.shouldReuse(video)) {
        return previousWrapper[key];
    }
    previousWrapper[key]?.reset(key, video);
    previousWrapper[key] = new WrapperClass(video, getActivatedVideoElementIfAvailable(), preferredCDNs);
    return previousWrapper[key];
}
